import React from 'react'
import minusPNG from '../../assets/icons/minus.png'
import greyMinusPNG from '../../assets/icons/minus-grey.png'
import plusPNG from '../../assets/icons/plus.png'
import greyPlusPNG from '../../assets/icons/plus-grey.png'
import './counter.scss'

const Counter = ({
  handleChange,
  count,
  disableIncrement,
  disAbleDecrement,
}) => (
  <div className="counter">
    <button
      disabled={disAbleDecrement}
      type="button"
      onClick={() => handleChange(count - 1)}
      className="counter-button"
    >
      <img
        className="counter-icon"
        alt="Decrease"
        src={disAbleDecrement ? greyMinusPNG : minusPNG}
      />
    </button>
    <p className="count">
      {count}
    </p>
    <button
      disabled={disableIncrement}
      type="button"
      onClick={() => handleChange(count + 1)}
      className="counter-button"
    >
      <img
        className="counter-icon"
        alt="Decrease"
        src={disableIncrement ? greyPlusPNG : plusPNG}
      />
    </button>
  </div>
)

export default Counter
